import React, { useState } from "react";
import { Stack, ThemeProvider } from "@mui/material";
import flowMuiTheme from "../../flow-core-components-shared/src/utils/flowMuiTheme";
import MuiPage from "../../flow-core-components-shared/src/components/MuiPage/MuiPage";

import Headline from "./Headline/Headline";
import FormContent from "./FormContent/FormContent";

/** Login component
 * @return {JSX.Element}
 */
const Login = () => {
    const [loading, setLoading] = useState(false);

    return (
        <ThemeProvider theme={flowMuiTheme}>
            <MuiPage variant="flow5" loading={loading}>
                <Stack spacing={4.5} mt="50px">
                    <Headline />
                    <FormContent setLoading={setLoading} />
                </Stack>
            </MuiPage>
        </ThemeProvider>
    );
};

export default Login;
